module.exports = __webpack_public_path__ + "static/media/logo-crm.eeb70628.png";